import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './content-header.scss';
import ArticleContentNav from '../../ArticleContentNav';
import { getFileName, isValid, isText, decodeTags } from '../../../../utils';

const ContentHeader = ({
    headline, isMobile, data, navHeads=[], category, articleLayout,
}) => {
    if (!isValid(data)) { return null; }
    const ref = useRef();
    const [contentHeaderBottom, setContentHeaderBottom] = useState(0);

    useEffect(() => {
        const onScroll = e => {
            setContentHeaderBottom(ref.current.getBoundingClientRect().bottom);
        };
        window.addEventListener("scroll", onScroll);
    
        return () => window.removeEventListener("scroll", onScroll);
    }, [contentHeaderBottom]);

    const imgSrc = (isValid(data.images)) ? isMobile ? isText(data.images.mobileImageOverride) ? data.images.mobileImageOverride : data.images.mobile.imageSrc : data.images.desktop : null;
    const bodyText = decodeTags(data.bodyText);
    const navs = navHeads.length > 0 ? true : false;
    let renderedContent;

    if (isMobile) {
        renderedContent = 
        <div className={`content-header-container ${!navs && 'no-nav'}`}>
            {articleLayout !== 'Content Hub'
                && <div className="content-header-category">{category}</div>}
            <div className="content-header">
            {navs && <ArticleContentNav navs={navHeads} isMobile={isMobile} hasContentHeader={true} />}
            {isValid(data.images) &&
                <div className="content-header-img-container">
                    <img className="content-header-img" src={imgSrc} alt={data.images.imageAlt || getFileName(imgSrc)} />
                    <a className="img-credit" href={data.photoCreditUrl} target="_blank" dangerouslySetInnerHTML={ { __html: data.photoCredit } }></a>
                </div>
            }
            <div className="content-header-text">
                <h1 className="content-header-headline">{headline}</h1>
                <p className="content-header-body" dangerouslySetInnerHTML={ { __html: bodyText } } ></p>
            </div>
        </div>
        </div>
    } else {
        renderedContent =
        <div className="content-header-container">
            {articleLayout !== 'Content Hub'
                && <div className="content-header-category">{category}</div>}
            <div className="content-header">
                <div className="content-header-text">
                    <h1 className="content-header-headline">{headline}</h1>
                    <p className="content-header-body" dangerouslySetInnerHTML={ { __html: bodyText } } ></p>
                </div>
                { isValid(data.images) &&
                    <div className="content-header-img-container">
                        <img className="content-header-img" src={imgSrc} alt={data.images.imageAlt || getFileName(imgSrc)} />
                        <a className="img-credit" href={data.photoCreditUrl} target="_blank" dangerouslySetInnerHTML={ { __html: data.photoCredit } }></a>
                    </div>
                }
            </div>
            {navs && <ArticleContentNav navs={navHeads} isMobile={isMobile} hasContentHeader={true} contentHeaderBottom={contentHeaderBottom} />}
        </div>
    }


  return (
      <div ref={ref}>
          {renderedContent}
      </div>
  );
};

ContentHeader.propTypes = {
    headline: PropTypes.string,
    isMobile: PropTypes.bool,
    data: PropTypes.object,
    navHeads: PropTypes.array,
    category: PropTypes.string,
};

export default ContentHeader;
